var AT_Slider ={
  
    owlSlider : function(){
      
        var customSlider = jQuery('.custom-designs-bg').owlCarousel({
            autoplay	: false
            ,loop 		: true
            ,nav		: false
            ,dots 		: false
            ,items		: 3
            ,mouseDrag	: true
            ,animateOut	: 'fadeOut',
            responsive: {
              1024: {
                items: 3
              },
              767: {
                items: 2
              },
              0: {
                items: 1
              }
            }
        });

        var arrivalSlider = jQuery('.new-arrivals-bg').owlCarousel({
            autoplay  : false
            ,loop     : true
            ,nav    : false
            ,dots     : false
            ,items    : 1
            ,mouseDrag  : true
            ,animateOut : 'fadeOut'
        });

        arrivalSlider.on('changed.owl.carousel', function(e) {
          jQuery('.owl-item').each(function(){
            jQuery(this).find('.new-arrivals-text').hide();
          });
          var current = e.item.index;
          $(e.target).find(".owl-item").eq(current).find(".new-arrivals-text").fadeIn(1500).css('display', 'table');
        });
      
        jQuery('.bg-slider-arrows .button-prev').click(function() {console.log("clicked");
          arrivalSlider.trigger('prev.owl.carousel');
          customSlider.trigger('prev.owl.carousel');
        });

        jQuery('.bg-slider-arrows .button-next').click(function() {console.log("clicked");
          arrivalSlider.trigger('next.owl.carousel');
          customSlider.trigger('next.owl.carousel');
        });

        if (jQuery(window).width() < 767) {
          if ($("#product-image").find(".item").length > 1) {
              var customSlider2 = jQuery('.product-image-gallery').owlCarousel({
                  autoplay  : false
                  ,loop     : true
                  ,nav    : true
                  ,dots     : true
                  ,items    : 1
                  ,mouseDrag  : true
                  /*,autoHeight: true*/
                  ,animateOut : 'fadeOut',
                  navText: ['<span class="button-prev text-center no-border"></span>', '<span class="button-next text-center no-border"></span>']
              });
            }
          else {
          	$("#product-image").addClass("no-product-carousel");
          }
          
        } //endif

	  }
  
  	,init : function(){
      this.owlSlider();
    }
  
}

var AT_Section_Btn = {
  
  scrollToAnimation: function(b, c, d) {
    var e = $(this).attr("href"),
        f = !1;
    if ($(e).length) var g = $(e),
        h = c ? g.offset().top + c : g.offset().top;
    (e || f) && ($("html, body").animate({
      scrollTop: h
    }, b || 1200), d.preventDefault())
  }
  
  ,scrollToClass: function() {
    var b = this;
    $(".section-btn").on("click", function(a) {
      b.scrollToAnimation.call(this, 1200, 0, a)
    })
  }
  
  ,init : function(){
    this.scrollToClass();
  }
  
}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery.fn.extend({
  scrollToMe: function() {
    if (jQuery(this).length) {
      var top = jQuery(this).offset().top - 200;
      jQuery('html,body').animate({
        scrollTop: top
      }, 500);
    }
  },
});;

jQuery(document).ready(function($) {
	
	AT_Slider.init();
  	AT_Section_Btn.init();
  
    $('.rating-links a').click(function() {
      $('.product-simple-tab ul li').removeClass('active');
      $('#tab_review_tabbed').addClass('active');
      $('.product-simple-tab .tab-content .tab-pane').removeClass('active');
      $('#tab_review').show();
      $('#tab_review_tabbed').scrollToMe();
      return false;
    });
      
});